(() => {
  const dialog = document.querySelector('[data-research-entry]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'europelab-research-confirmation-2026-11-03-v1';
  try { if (sessionStorage.getItem(key) === 'confirmed') return; } catch (_) {}
  const form = dialog.querySelector('[data-research-entry-form]');
  const checkbox = dialog.querySelector('[data-research-confirm]');
  const enter = dialog.querySelector('[data-research-enter]');
  let confirmed = false;
  const sync = () => { enter.disabled = !checkbox.checked; };
  checkbox.addEventListener('change', sync);
  dialog.addEventListener('cancel', event => event.preventDefault());
  dialog.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); } });
  dialog.addEventListener('close', () => {
    if (!confirmed && dialog.isConnected) { dialog.showModal(); return; }
    document.documentElement.removeAttribute('data-research-entry-open');
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!checkbox.checked || !form.checkValidity()) { form.reportValidity(); return; }
    try { sessionStorage.setItem(key, 'confirmed'); } catch (_) {}
    confirmed = true;
    dialog.close();
  });
  sync();
  document.documentElement.setAttribute('data-research-entry-open', '');
  dialog.showModal();
})();
